import { render, staticRenderFns } from "./LeaveBalanceByStaff.vue?vue&type=template&id=51ec33e0"
import script from "./LeaveBalanceByStaff.vue?vue&type=script&lang=js"
export * from "./LeaveBalanceByStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports